import React from 'react';
import styled from 'styled-components';
import HomeBannerImage from '../../../../images/brooke-unsplash.jpg';

interface Props {}

const BannerText = styled.div`
  width: 100%;
  text-align: center;
  position: absolute;
  z-index: 21;
  top: 50%;
  transform: translate(0, -50%);
  @media (max-width: 767px) {
    padding: 10px;
  }
  h4 {
    padding: 0;
    color: #fff;
    font-size: 40px;
    font-weight: 900;
    text-align: center;
    margin: 0 auto;
    line-height: 38px;
    @media (max-width: 767px) {
      font-size: 28px;
      line-height: 32px;
    }
  }
  p {
    padding: 0;
    margin-top: 10px;
    color: #fff;
    line-height: 1.2;
    @media (max-width: 767px) {
      font-size: 18px;
    }
  }
`;

const HomeBanner: React.FC<Props> = (props) => {
  return (
    <div className="swiper-containers">
      <div className="swiper-wrapper">
        <div className="swiper-slide">
          <a
            href="#a"
            style={{
              background: `url(${HomeBannerImage}) center`,
              backgroundSize: 'cover',
            }}
          />
          <div className="opcity-box" />
          <BannerText>
            <h4 style={{ textShadow: '3px 3px 9px rgba(0, 0, 0, 0.25)' }}>
              Khám phá ẩm thực quanh bạn?
            </h4>
            <p>Nhà hàng, quán ăn, tiệm cà phê và những trải nghiệm ẩm thực khác</p>
          </BannerText>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
